import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller } from 'react-hook-form';
import dayjs from 'dayjs';
import { useTheme } from '@mui/material';

type DatePickerInputProps = {
  label: string;
  name: string;
  control: any;
  required?: boolean;
  fullWidth?: boolean;
  minDate?: any;
  maxDate?: any;
};

const DatePickerInput = ({
  name,
  control,
  label,
  required = false,
  fullWidth = false,
  minDate = dayjs(),
  maxDate,
}: DatePickerInputProps) => {
  const theme = useTheme();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: { value: required, message: `${label} is required *` },
        validate: (value) => {
          if (maxDate && dayjs(value).isAfter(maxDate, 'day')) {
            return `${label} cannot be in the future`;
          }

          // null means no lower bound
          if (minDate === null) return true;

          if (minDate) {
            return (
              !dayjs(value).isBefore(minDate, 'day') ||
              `${label} cannot be before ${dayjs(minDate).format('MM/DD/YYYY')}`
            );
          }

          return (
            !dayjs(value).isBefore(dayjs(), 'day') ||
            `${label} cannot be before today`
          );
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            {...field}
            minDate={minDate ?? undefined} // Disallow dates before today if minDate is not provided
            maxDate={maxDate}
            label={label}
            sx={{
              width: '100%',
              [theme.breakpoints.up('desktop')]: {
                width: fullWidth ? '100%' : '33%',
              },
            }}
            slotProps={{
              textField: {
                error: !!error,
                helperText: error?.message,
              },
            }}
          />
        </LocalizationProvider>
      )}
    />
  );
};

export default DatePickerInput;
